<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-container>
            <v-row>
                <v-col>

                    <v-card class="elevation-6">
                                                <v-row>
                            <v-col class="pb-0">
                                <v-card class="elevation-0">
                                    <v-card-text>
                                        <p class="title text--primary ml-3">
                                            Αναφορές</p>
                                    </v-card-text>

                                    <v-row>
                                        <v-col class="mx-5">

                                            <p class="subtitle-1 text--primary ml-3">
                                                Πλήθος Επιλεγμένων Βιβλίων από φοιτητές ανά Μάθημα</p>

                                        </v-col>
                                        <v-divider vertical></v-divider>
                                        <v-col class="mx-5">
                                            <p class="subtitle-1 text--primary ml-3">
                                                Πλήθος Παραδόσεων Βιβλίων ανά μάθημα</p>
                                        </v-col>
                                    </v-row>
                                    <v-divider></v-divider>
                                    <v-row>
                                        <v-col class="mx-5">
                                            <v-card class="elevation-0 height:20%" overlined>
                                                <v-row>
                                                    <v-col xl="6" lg="12" md="12" cols="12" sm="12">
                                                        <div class="subtitle-2 font-weight-light text--primary ml-3 mt-5">
                                                            Περίοδος*
                                                        </div>
                                                        <v-btn @click="openDatePicker(1)"
                                                               block
                                                               :disabled="$store.getters.amountOfSelectedBooksPDF.isLoading && $store.getters.amountOfSelectedBooksXLSX.isLoading ? true : false"
                                                               color="orange"
                                                               outlined>
                                                            <v-icon class="mr-1">date_range</v-icon>
                                                            Επιλέξτε ημερομηνίες
                                                        </v-btn>
                                                    </v-col>
<!--                                                    <v-col xl="6" lg="12" md="12" cols="12" sm="12">-->
<!--                                                        <div class="btns">-->
<!--                                                        <p class="subtitle-2  mt-5">Αναφορά με το πλήθος φοιτητών που-->
<!--                                                        επέλεξαν κάθε βιβλίο ταξινομημένοι ανά μάθημα στο διάστημα Από - -->
<!--                                                        Εώς.</p>-->
<!--                                                        </div>-->
<!--                                                    </v-col>-->
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <v-btn :loading="$store.getters.amountOfSelectedBooksPDF.isLoading" @click="amountOfSelectedBooksPDF"
                                                               :disabled="amountDates.length == 0 ? true : false"
                                                               block
                                                               color="red"
                                                               outlined>Αναφορά PDF
                                                            <v-icon>get_app</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col>
                                                        <v-btn :loading="$store.getters.amountOfSelectedBooksXLSX.isLoading" @click="amountOfSelectedBooksXLSX"
                                                               :disabled="amountDates.length == 0 ? true : false"
                                                               block
                                                               color="info"
                                                               outlined>Αναφορά XLSX
                                                            <v-icon>get_app</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                            </v-card>
                                        </v-col>
                                        <v-col class="mx-5">
                                            <v-card class="elevation-0" overlined>
                                               <v-row>
                                                    <v-col xl="6" lg="12" md="12" cols="12" sm="12">
                                                        <div class="subtitle-2 font-weight-light text--primary ml-3 mt-5">
                                                            Περίοδος*
                                                        </div>
                                                        <v-btn @click="openDatePicker(2)"
                                                               block
                                                               :disabled="$store.getters.deliveredBooksPDF.isLoading && $store.getters.deliveredBooksXLSX.isLoading ? true : false"
                                                               color="orange"
                                                               outlined>
                                                            <v-icon class="mr-1">date_range</v-icon>
                                                            Επιλέξτε ημερομηνίες
                                                        </v-btn>
                                                    </v-col>

<!--                                                    <v-col xl="6" lg="12" md="12" cols="12" sm="12">-->
<!--                                                        <div class="btns">-->
<!--                                                        <p class="subtitle-2 mt-5">Αναφορά με τις παραδόσεις βιβλίων ανά-->
<!--                                                            μάθημα στο χρονικό διάστημα Από - Εώς</p>-->
<!--                                                        </div>-->
<!--                                                    </v-col>-->

                                                </v-row>
                                                <v-row class="footer">
                                                    <v-col>
                                                        <v-btn :loading="$store.getters.deliveredBooksPDF.isLoading" @click="deliveredBooksPDF"
                                                               :disabled="deliveredDates.length == 0 ? true : false"
                                                               block
                                                               color="red"
                                                               outlined>
                                                            Αναφορά PDF
                                                            <v-icon>get_app</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col>
                                                        <v-btn :loading="$store.getters.deliveredBooksXLSX.isLoading" @click="deliveredBooksXLSX"
                                                               :disabled="deliveredDates.length == 0 ? true : false"
                                                               block
                                                               color="info"
                                                               outlined>
                                                            Αναφορά XLSX
                                                            <v-icon>get_app</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>

                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-divider></v-divider>
                        <v-row>
                            <v-col cols="6" class="ml-5">
                                <v-card class="elevation-0" >
                                    <v-row>
                                        <v-col>
                                            <v-card class="elevation-0" overlined>
                                                <p class="subtitle-1 text--primary ml-3">
                                                    Διανομή Βιβλίων</p>
                                            </v-card>
                                        </v-col>

                                    </v-row>
                                    <v-divider></v-divider>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-btn :loading="$store.getters.booksDistributionXLSX.isLoading" @click="booksDistributionXLSX" block color="info"
                                                   outlined>Αναφορά XLSX
                                                <v-icon>get_app</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col xl="6" lg="12" md="12" cols="6" sm="12">
                                            <p class="subtitle-2">ΠΡΟΣΟΧΗ! Η συγκεκριμένη αναφορά δείχνει τα
                                                συγκεντρωτικά στοιχεία της προηγούμενης ημέρας και αφορά την
                                                τρέχουσα περίοδο.</p>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                            <v-col cols="5" class="ml-5" v-show="true">
	                            <v-card class="elevation-0" >
		                            <v-row>
			                            <v-col>
				                            <v-card class="elevation-0" overlined>
					                            <p class="subtitle-1 text--primary ml-3">
						                            Συγκεντρωτικά στοιχεία δηλώσεων και παραδόσεων</p>
				                            </v-card>
			                            </v-col>

		                            </v-row>
		                            <v-divider></v-divider>
		                            <v-row>
			                            <v-col xl="6" lg="12" md="12" cols="6" sm="12">
				                            <v-btn @click="openDatePicker(3)"
				                                   block
				                                   :disabled="$store.getters.publisherStatementAndDeliveryStatsReport.isLoading ? true : false"
				                                   color="orange"
				                                   outlined>
					                            <v-icon class="mr-1">date_range</v-icon>
					                            Επιλέξτε ημερομηνίες
				                            </v-btn>
			                            </v-col>
			                            <v-col cols="6">
				                            <v-btn :loading="$store.getters.publisherStatementAndDeliveryStatsReport.isLoading" @click="publisherStatementAndDeliveryStatsReportXLSX"
				                                   :disabled="publisherStatementAndDeliveryStatsReportDates.length < 2 ? true : false"
				                                   block color="info"
				                                   outlined>Αναφορά XLSX
					                            <v-icon>get_app</v-icon>
				                            </v-btn>
			                            </v-col>

		                            </v-row>
	                            </v-card>
                            </v-col>
                        </v-row>
<!--                        <v-divider/>-->
<!--                        <v-row class="mt-10">-->
<!--                            <v-col>-->
<!--                                <v-card class="elevation-0" >-->
<!--                                    <v-row>-->
<!--                                        <v-col class=" pt-0" cols="3">-->
<!--&lt;!&ndash;                                            <p class="subtitle-1 text&#45;&#45;primary ml-3">&ndash;&gt;-->
<!--&lt;!&ndash;                                                Επιλεγμένα βιβλία από φοιτητές για κατ' οίκον παράδοση (Εαρινό 2020-21)</p>&ndash;&gt;-->

<!--                                        </v-col>-->
<!--                                        <v-col class=" pt-0" cols="3">-->

<!--                                        </v-col>-->
<!--                                        <v-divider vertical></v-divider>-->
<!--                                        <v-col class=" pt-0" cols="5">-->
<!--                                            <p class="subtitle-1 text&#45;&#45;primary ml-3">-->
<!--                                                Έλεγχος αρχείου Συγκεντρωτικής Λίστας-->
<!--                                                <v-tooltip top v-if="errorToolTip">-->
<!--                                                    <template v-slot:activator="{ on, attrs }">-->
<!--                                                        <v-icon color="red" class="mr-3" v-on="on">info</v-icon>-->
<!--                                                    </template>-->
<!--                                                    <span>{{getErrorMessage()}}</span>-->
<!--                                                </v-tooltip>-->
<!--                                            </p>-->

<!--                                        </v-col>-->
<!--                                    </v-row>-->
<!--                                    <v-divider></v-divider>-->
<!--                                    <v-row>-->
<!--                                        <v-col class="mx-5 pt-0">-->
<!--                                            <v-card class="elevation-0" overlined>-->
<!--                                                <v-row>-->
<!--                                                    <v-col>-->
<!--                                                        <v-btn :disabled="false"-->
<!--                                                               :loading="$store.getters.homeDeliveryXLSX.isLoading"-->
<!--                                                               @click="homeDeliveryXLSX('2021-03-22', '2021-04-05')"-->
<!--                                                               block-->
<!--                                                               v-show="false"-->
<!--                                                               color="info"-->
<!--                                                               outlined>-->
<!--                                                            Αναφορά XLSX-->
<!--                                                            <v-icon>get_app</v-icon>-->
<!--                                                        </v-btn>-->
<!--                                                    </v-col>-->
<!--                                                    <v-col>-->

<!--                                                    </v-col>-->

<!--                                                </v-row>-->

<!--                                            </v-card>-->
<!--                                        </v-col>-->
<!--                                        <v-col class="mx-5 pt-0">-->
<!--                                            <v-card class="elevation-0" overlined>-->
<!--                                                <v-row>-->
<!--                                                    <v-col>-->
<!--                                                        <v-btn @click="checkeFilesList" color="primary"-->
<!--                                                               block-->
<!--                                                               outlined>Έλεγχος</v-btn>-->
<!--                                                    </v-col>-->
<!--                                                    <v-col>-->
<!--                                                        <v-btn :disabled="!$store.getters.distributionStatus.pdfUploaded"-->
<!--                                                                @click="checkFileListDownload('declaration')" block color="red" outlined>-->
<!--                                                            Αναφορά PDF-->
<!--                                                            <v-icon>get_app</v-icon>-->
<!--                                                        </v-btn>-->
<!--                                                    </v-col>-->
<!--                                                    <v-col>-->
<!--                                                        <v-btn v-if="$store.getters.distributionStatus.excelStatus == 'File uploaded with no errors' ||-->
<!--                                                                $store.getters.distributionStatus.excelStatus == 'File uploaded with errors'"-->
<!--                                                                @click="checkFileListDownload('report')" block color="info" outlined>-->
<!--                                                            Αναφορά XLSX-->
<!--                                                            <v-icon>get_app</v-icon>-->
<!--                                                        </v-btn>-->
<!--                                                        <v-btn v-else-->
<!--                                                               disabled-->
<!--                                                               block color="info" outlined>-->
<!--                                                            Αναφορά XLS-->
<!--                                                            <v-icon>get_app</v-icon>-->
<!--                                                        </v-btn>-->
<!--                                                    </v-col>-->
<!--                                                </v-row>-->

<!--                                            </v-card>-->
<!--                                        </v-col>-->
<!--                                    </v-row>-->
<!--                                </v-card>-->
<!--                            </v-col>-->
<!--                        </v-row>-->
                    </v-card>

                </v-col>
            </v-row>
        </v-container>

        <div class="text-center">
            <v-dialog max-width="500"
                      persistent
                      v-model="datePicker">
                <v-card flat>
                    <div class="text-center">
                        <v-date-picker :events="arrayEvents" :max="maxDate"
                                       :min="minDate"
                                       class="elevation-0"
                                       color="primary"
                                       first-day-of-week="1"
                                       full-width
                                       range
                                       locale="el"
                                       v-model="dates"></v-date-picker>
                    </div>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn
                                @click="closeDatePicker"
                                color="primary"
                                text>
                            Κλείσιμο
                        </v-btn>
                        <v-btn
                                @click="selecteDates"
                                color="primary"
                                text>
                            ΟΚ
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>

</template>

<script>

    import utils from '../../utilities'
    import request from '../../requests'
    import service from '../../service'
    import 'vue-material-design-icons/styles.css'

    export default {
        name: "Reports",
        data: () => ({
            amountDates: [],
            deliveredDates: [],
            publisherStatementAndDeliveryStatsReportDates: [],
            amountOfSelectedBooks: false,
            amountOfDeliveredBooks: false,
            publisherStatementAndDeliveryStatsReportDatePickerMode: false,
            datePicker: false,
            minDate: '',
            maxDate: '',
            dates: [],
            arrayEvents: [],
            allBooks: [],
            academicPeriod: [],
            distributionPeriod: [],
            distribution: [],
            institutionPeriod: [],
            allInstitution: [],
            checkedFileFormat: '',
            deliveriesFile: [],
            solemnDeclaration: [],
        }),

        methods: {

            checkeFilesList(){

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getDistributionStatus(token, this.getDistributionStatusCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getDistributionStatusCallBack(response) {
                this.$store.commit('setDistributionStatus', response);
                this.$store.commit('setLoadingModal', false);
            },

            openDatePicker(id) {

                if (id == 1) {
                    this.dates =  this.amountDates;
                    this.amountOfSelectedBooks = true;
                    this.amountOfDeliveredBooks = false;
                    this.publisherStatementAndDeliveryStatsReportDatePickerMode = false;
                }
                else if (id == 2) {
                    this.dates = this.deliveredDates;
                    this.amountOfSelectedBooks = false;
                    this.amountOfDeliveredBooks = true;
                    this.publisherStatementAndDeliveryStatsReportDatePickerMode = false;
                }
                else if (id == 3) {
                    this.dates = this.publisherStatementAndDeliveryStatsReportDates;
                    this.amountOfSelectedBooks = false;
                    this.amountOfDeliveredBooks = false;
                    this.publisherStatementAndDeliveryStatsReportDatePickerMode = true;
                }
                this.maxDate = utils.createPickerCurrentDate();
                // this.dates = [];
                this.datePicker = true;
            },

            closeDatePicker(){

                this.dates = [];
                this.datePicker = false;
            },

            uploadFile(file,type) {

                if (file != undefined) {
                    const formData = new FormData();
                    formData.set('name', file);
                    var token = utils.getLocalStorage('token');
                    if (token != null) {
                        this.$store.commit('setLoadingModal', true);
                        if('declaration'=== type) {
                            request.uploadSolemnDeclaration(token, formData, this.uploadSolemnDeclarationCallBack)
                        }else {
                            request.uploadDistributionFile(token, formData, this.uploadDistributionFileCallBack)
                        }
                    }
                    else {
                        this.$store.commit('setloginModal', true);
                    }
                }
            },

            uploadSolemnDeclarationCallBack(response) {
                this.$store.commit('setLoadingModal', false);
                utils.setErrorPopup('Έχετε ανεβάσει επιτυχώς την συνοδευτική Υπεύθυνη Δήλωση.')
            },

            uploadDistributionFileCallBack(response) {
                this.$store.commit('setLoadingModal', false);
                utils.setErrorPopup('Το αρχείο μεταφορτώθηκε επιτυχώς. Παρακαλούμε πατήστε Έλεγχος και κατεβάστε την Αναφορά που επισημαίνονται πιθανές διορθώσεις.');
            },

            selecteDates(){

                if (this.dates.length > 0) {
                    this.dates = utils.sortDatesArray(this.dates);
                    if (this.amountOfSelectedBooks) {
                        this.amountDates = this.dates
                    }
                    else if (this.amountOfDeliveredBooks) {
                        this.deliveredDates = this.dates;
                    }
                    else if (this.publisherStatementAndDeliveryStatsReportDatePickerMode) {
                        this.publisherStatementAndDeliveryStatsReportDates = this.dates;
                    }
                }
                this.datePicker = false;
            },

            amountOfSelectedBooksPDF() {

                service.startServiceAmountOfPDF(this.amountDates);
            },

            amountOfSelectedBooksXLSX() {

                service.startServiceAmountOfXLSX(this.amountDates);
            },

            deliveredBooksPDF() {

                service.startServiceDeliveredBooksPDF(this.deliveredDates);
            },

            deliveredBooksXLSX() {

                service.startServiceDeliveredBooksXLSX(this.deliveredDates);
            },

            booksDistributionXLSX() {

                service.startServiceBooksDistributionXLSX();
            },

            publisherStatementAndDeliveryStatsReportXLSX() {

                if (this.publisherStatementAndDeliveryStatsReportDates.length >= 2) {
                    service.startStatementReport(this.publisherStatementAndDeliveryStatsReportDates[0], this.publisherStatementAndDeliveryStatsReportDates[1]);
                }
            },

            homeDeliveryXLSX(fromDate, toDate) {

                service.startServiceHomeDeliveryXLSX(fromDate, toDate);
                // var obj= {
                //     type:"publisherLibraryOrdersDelivered",
                //     requesterId:null,
                //     format:"pdf",
                //     academicYear:null,
                //     period:null,
                //     fromDate:"2019-01-02",
                //     toDate:"2019-08-25",
                //     institutionId:43,
                //     distributionPointId:null
                // };
                // var token = utils.getLocalStorage('token');
                // if (token != null) {
                //     this.$store.commit('setLoadingModal', true);
                //     request.reports(token, obj, this.reportsCallBack);
                // }
                // else {
                //     this.$store.commit('setloginModal', true);
                // }

            },

            homeDeliveryXLSX1(fromDate, toDate) {

                service.startServiceHomeDeliveryXLSX1(fromDate, toDate);
            },

            reportsCallBack(response){

                this.$store.commit('setLoadingModal', false);
            },

            checkFileListDownload(format) {

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    this.checkedFileFormat = format;
                    request.getDistributionFile(token, format,  this.getDistributionFileCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getDistributionFileCallBack(response) {

                this.$store.commit('setLoadingModal', false);
                //Create a Blob from the PDF Stream
                if (this.checkedFileFormat == 'declaration') {
                    utils.downLoadPDF(response);
                }
                else {
                    utils.downLoadXLSX(response);
                }

            },

            getErrorMessage(){

                if (Object.keys(this.$store.getters.distributionStatus).length > 0) {
                    var message;
                    if (this.$store.getters.distributionStatus.excelStatus == 'File uploaded with errors') {
                        message = 'Το αρχείο ανέβηκε με λάθη. ';
                    }
                    else  if (this.$store.getters.distributionStatus.excelStatus == 'File uploaded with no errors') {
                        message = 'Η διανομή έχει ολοκληρωθεί επιτυχώς κατά ' + this.$store.getters.distributionStatus.percentage + '. ';
                    }
                    else  {
                        message = 'Δεν υπάρχει ανεβασμένο αρχείο Συγκεντρωτικής Λίστας. ';
                    }
                    if(this.$store.getters.distributionStatus.pdfUploaded){
                        message +='Η Υπεύθυνη Δήλωση έχει υποβληθεί επιτυχώς.';
                    }else{
                        message +='Η Υπεύθυνη Δήλωση δεν έχει υποβληθεί.';
                    }
                    return  message;
                }
                return ''
            }

        },

        computed: {

            errorToolTip: function () {
                if (Object.keys(this.$store.getters.distributionStatus).length > 0) {
                    return true
                }
                return false
            }
        },

        created() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>

.btns{
    height: 4em;
}
</style>
